import PropTypes from "prop-types";
import { classNamePropType, sizePropType, statusPropType, shapePropType, namePropType } from "../../common";

/**
 * PropTypes for Avatar component
 *
 * @property {string} [src] - Image source URL
 * @property {string} [name] - User name for generating initials
 * @property {('small'|'default'|'medium'|'large')} [size] - Avatar size variant
 * @property {('active'|'inactive'|'pending')} [status] - Status indicator
 * @property {string} [borderColor] - Custom border color (CSS color value)
 * @property {('circle'|'square')} [appearance] - Avatar shape
 * @property {boolean} [selection] - Enable file upload/selection mode
 * @property {number} [customWidth] - Custom width in pixels (overrides size)
 * @property {string} [className] - Additional CSS classes
 */
export const avatarPropTypes = {
  src: PropTypes.string,
  name: namePropType,
  size: sizePropType,
  status: statusPropType,
  borderColor: PropTypes.string,
  appearance: shapePropType,
  selection: PropTypes.bool,
  customWidth: PropTypes.number,
  className: classNamePropType,
};
